<template>
    <div class="position-relative p-3">
        <!-- Begin Page Content -->
        <div class="report-section">
            <div class="row">
                <div class="col-12 ">
                    <div class="repoerPT">
                         <div class="fixedTop nav-item d-flex align-items-center justify-content-end" v-if="$route.name == 'TestReport'"> 
                            <router-link  class="themecolor whiteButton d-inline-flex align-items-center justify-content-end medium" to="/upload-test-reports"><span class="plusCircle mb-0 bg-white mr-2"><feather type="upload"></feather></span> Upload Lab Test</router-link> 
                            <!-- <a href="#" class="whiteButton redBG ml-2 d-inline-flex align-items-center"><span class="plusCircle mb-0 bg-white mr-2"><feather type="trash"></feather></span> Delete</a> -->
                        </div>
                        <div class="position-relative">
                            <div class="table-reponsive">
                                <table class="table separateTable">
                                    <thead>
                                        <tr>
                                            <!-- <th class="checkDel">
                                                <label class="checkbox">
                                                  <input type="checkbox">
                                                  <span class="checkmark"></span>
                                                </label>
                                            </th> -->
                                            <th>Date</th>
                                            <th>Report Type</th>
                                            <th>Notes</th>
                                            <!-- <th>Status</th> -->
                                            <th class="text-right">View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="pageLoader">
                                        <table-loader ></table-loader>
                                    </tbody>
                                    <tbody v-else-if="!pageLoader && !testReportList.totalRecords">
                                        <no-record :type="'table'" :colspan="5"></no-record>
                                    </tbody>
                                    <tbody v-else-if="!pageLoader && testReportList.totalRecords && testReportList.totalRecords > 0 ">
                                        <tr v-for="list in testReportList.records">
                                            <!-- <td class="checkDel">
                                               <label class="checkbox">
                                                  <input type="checkbox">
                                                  <span class="checkmark"></span>
                                                </label> 
                                            </td> -->
                                            <td>
                                                <p v-if="list.created == '' || list.created == null || list.created == '0000-00-00 00:00:00'">-</p>
                                                <p v-else>{{formatTestDate(list.created)}}</p>
                                            </td>
                                            <td>
                                                <p>
                                                    <span>{{(list.doc_type_id) ? (list.doc_type_id != 5)?$env_var.uploadDocumentTypeJson[list.doc_type_id] : list.doc_type_other || '-' : '-'}}</span>
                                                </p>
                                            </td>
                                            <td>
                                                <p>{{list.notes || '-'}}</p>
                                            </td>
                                            <!-- <td>
                                                <p v-if="list.status != null" :class="(list.status)?'alert alert-success':'alert alert-warning'">{{(list.status)?'Approved':'Pending'}}</p>
                                                <p v-else>-</p>
                                            </td> -->
                                            <!-- <td>
                                                <a class="btn-blue" :href="$env_var.testReportLink+'?img='+list.pdfPath" v-if="list.pdfPath != '' && list.pdfPath != null" target="_blank">Click Here</a>
                                                <a href="#" v-else>No Document</a>
                                            </td> -->
                                            <td>
                                                <div class="btnEdit d-flex align-items-center justify-content-end">
                                                    <!-- <a href="javascript:void(0)" @click.prevent="redirection('AnalyzeReport',{id:list._id})"><feather type="eye"></feather></a>
                                                    <a class="ml-2" :href="$env_var.testReportLink+'?img='+list.pdfPath" v-if="list.pdfPath != '' && list.pdfPath != null" target="_blank"><feather type="download"></feather></a> -->
                                                    <a :href="$env_var.reports_link + '?id=' + list.user_id + '&img=' + list.document" target="_blank"><feather type="eye"></feather></a>
                                                </div>
                                            </td>
                                      </tr>
                                    </tbody>
                                    
                                </table>
                            </div>
                            <app-pagination :totalRecords ="testReportList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="testReportList.totalRecords && testReportList.totalRecords > pageLimit"></app-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment"
    export default {
        name: "test-report",
        data() {
            return {
                page : 1,
                pageLimit : 10,
                pageLoader : false,

            };
        },
        methods:{
            formatTestDate(val){
                return moment(val).format('Do MMM YYYY, h:mm a')
            },
            listing(){
                let inputJson = {
                    'globalParams' :{
                        page : this.page,
                        perPage : this.pageLimit,

                    },'localParams' :{'parameter' : this}
                }
                this._runGetPatientTestReportList(inputJson)
            },
        },
        created() {
            this.pageName("Test/Reports");
            this.listing()
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/test-report.vue